// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Column_wrapper__TE_6b","columns":"Column_columns__RybZ2","column":"Column_column__C0rhX","legend":"Column_legend__6iUlo"};